const getReferralReplyDisplayConfig = (record) => {
  const status = record.referral_reply_status;
  const hasHistoricalFailure = record.has_failed_referral_replies && status !== 'failure';

  if (status === 'failure') {
    return {
      iconColor: '#ff4d4f',
      showHistoricalFailureCorner: false,
      tooltipTitle: 'Latest referral reply failed',
    };
  }

  if (status === 'success') {
    const sentDetails = `Latest reply sent on ${record.referral_reply_sent_at} by ${record.referral_reply_sent_by}`;
    return {
      iconColor: '#52c41a',
      showHistoricalFailureCorner: hasHistoricalFailure,
      tooltipTitle: hasHistoricalFailure
        ? `${sentDetails}. One or more earlier replies failed`
        : sentDetails,
    };
  }

  return {
    iconColor: '#faad14',
    showHistoricalFailureCorner: hasHistoricalFailure,
    tooltipTitle: hasHistoricalFailure
      ? 'Latest reply queued. One or more earlier replies failed'
      : 'Latest reply queued to be sent',
  };
};

export default getReferralReplyDisplayConfig;
